module.exports = __webpack_public_path__ + "static/media/home white.6af85fd2.png";